const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/w9i5fobs558q3-UZ/image;s=644x461",
        title: "Глинка 3/2/6 Люкс квартира после капитального ремонта, дом Новострой",
        price: "128 000 у.е.",
        location: "Ташкент, Яшнабадский район "
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/f6alm59bwnh91-UZ/image;s=644x461",
        title: "ЖК PREMIUM CHILONZOR 4 ком 125 кв.м ориентир Ц квартал ГАИ",
        price: "87 000 у.е.",
        location: "Ташкент, Чиланзарский район ",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/7n561qry742m-UZ/image;s=644x461",
        title: "С мебелью и техникой 3 комнатная. 80 квадратов. Чиланзар 5 квартал.",
        price: "57 000 у.е.",
        location: "Ташкент, Чиланзарский район ",
    },
]

export default data;